// Índice das traduções em português (Brasil)
import { commonPt } from './common';
import { formsPt } from './forms';
import { navigationPt } from './navigation';
import { vehiclesPt } from './vehicles';
import { pagesPt } from './pages';
import { homePt } from './home';
import { footerPt } from './footer';
import { financingPt } from './financing';
import { consignmentsPt } from './consignments';
import { buyDirectPt } from './buyDirect';
import { weSearchForYouPt } from './weSearchForYou';
import { contactPt } from './contact';
import { aboutPt } from './about';
import { bookingPt } from './booking';
import { formsUiPt } from './formsUi';
import { catalogPt } from './catalog';
import { sitePt } from './site';

export const pt = {
  common: commonPt,
  forms: formsPt,
  navigation: navigationPt,
  vehicles: vehiclesPt,
  home: homePt,
  pages: pagesPt,
  footer: footerPt,
  financing: financingPt,
  consignments: consignmentsPt,
  buyDirect: buyDirectPt,
  weSearchForYou: weSearchForYouPt,
  contact: contactPt,
  about: aboutPt,
  booking: bookingPt,
  formsUi: formsUiPt,
  catalog: catalogPt,
  site: sitePt,
};
